<template>
    <svg :class="imageClass">
      <use v-if="imageName == 'accept'" xlink:href="@/assets/grayhound/images/sprite.svg#accept"></use>
      <use v-if="imageName == 'close-app'" xlink:href="@/assets/grayhound/images/sprite.svg#close-app"></use>
      <use v-if="imageName == 'close'" xlink:href="@/assets/images/sprite.svg#close"></use>
      <use v-if="imageName == 'arrow-expand'" xlink:href="@/assets/grayhound/images/sprite.svg#arrow-expand"></use>
      <use v-if="imageName == 'balance'" xlink:href="@/assets/grayhound/images/sprite.svg#balance"></use>
      <use v-if="imageName == 'betting-history'" xlink:href="@/assets/images/sprite.svg#betting-history"></use>
      <use v-if="imageName == 'fs-off'" xlink:href="@/assets/grayhound/images/sprite.svg#fs-off"></use>
      <use v-if="imageName == 'fs-on'" xlink:href="@/assets/grayhound/images/sprite.svg#fs-on"></use>
      <use v-if="imageName == 'volume-up'" xlink:href="@/assets/images/sprite.svg#volume-up"></use>
      <use v-if="imageName == 'volume-down'" xlink:href="@/assets/images/sprite.svg#volume-down"></use>
    </svg>
</template>
<script>

export default {
  props: {
    imageClass: {
      type: String,
      default: 'a-vg-icon'
    },
    imageName: {
      type: String,
      required: true
    }
  }
}
</script>
